import React, {Fragment} from 'react';
import {Dropdown, Tabs, Flex, Timeline, Link, Popup, Edit, Card, Goals, Button, Breadcrumbs, Layout} from 'components';
import {useList, get, moment, useNamedSelector, useState} from 'helpers';
import {settings, goals} from 'store';

export function Track({match: {params: {id}}}) {
  const {chartPeriod = 7} = useNamedSelector('goals.options');
  const [position, setPosition] = useState(0);
  const [start, end] = useNamedSelector('calendar.range', {length: chartPeriod, position});
  const {today} = useNamedSelector('calendar.days');
  const {goal, editable} = useNamedSelector('goals.details', {id, context: 'goals'});
  const progress = useNamedSelector('goals.progressIndex');
  const [list, Last] = useList(useNamedSelector('calendar.reversePeriod', goal.starting_date ?? today.unix(), today.unix()));
  return (
    <Fragment>
      <Layout.Header>
        <Flex>
          <div className="pull-left">
            <h4>My Progress</h4>
            <Breadcrumbs className="small-spacing">
              <Link to="/goals/">Goals</Link>
              <Link className="multi-line" to={`/goals/${id}/`}>{goal.name}</Link>
            </Breadcrumbs>
          </div>
          <Button to={`/goals/${id}/`} className={['small', 'borderless']} icon="return">Back</Button>
        </Flex>
      </Layout.Header>
      <Card className="medium">
        <Tabs className="first">
          <Tabs.Tab onClick={() => settings.set({module: 'goals', key: 'chartPeriod', value: 7}) || setPosition(0)} pressed={chartPeriod === 7}>7 days</Tabs.Tab>
          <Tabs.Tab onClick={() => settings.set({module: 'goals', key: 'chartPeriod', value: 30}) || setPosition(0)} pressed={chartPeriod === 30}>30 days</Tabs.Tab>
          <Tabs.Tab onClick={() => settings.set({module: 'goals', key: 'chartPeriod', value: 90}) || setPosition(0)} pressed={chartPeriod === 90}>90 days</Tabs.Tab>
          <b className="pull-right">{start.range(end)}</b>
        </Tabs>
        <br />
        <Goals.Single.TrackStats id={id} />
        <Goals.Single.Chart id={id} force />
      </Card>
      {editable &&
        <>
          <Flex className={['middle', 'justified', 'medium-spacing']}>
            <h5>Enter your {goal.progressType === 'cumulative' ? 'total' : 'incremental'} results</h5>
            <Dropdown inline Popup={Mode} className="white-dropdown" id={id}>
              {goal.progressType === 'cumulative' ? 'Aggregate sum' : 'Incremental entries'}
            </Dropdown>
          </Flex>
          <Timeline>
            { list.map(ts =>
              <Timeline.Item key={ts} date={moment.unix(ts).calendar()}>
                {goal.starting_date === ts
                  ? <Edit
                      type="number"
                      value={goal.starting_value}
                      setValue={(starting_value, id) => goals.dispatch.upsert({starting_value, id})}
                      name={goal.id}
                      placeholder="Enter starting value.."
                    />
                  : <Edit
                      className="bold"
                      type="number"
                      setValue={goals.dispatch.updateProgress}
                      name={goal.id + '_' + ts}
                      value={get(progress[goal.id + '_' + ts], 'value', '')}
                      placeholder="Enter result.."
                    />
                }
              </Timeline.Item>
            ) }
          </Timeline>
          <Last />
        </>
      }
    </Fragment>
  );
}

function Mode({id}) {
  const {goal} = useNamedSelector('goals.details', {id});
  const change = (progressType) => goals.dispatch.upsert({id, progressType });
  return (
    <Popup.Menu>
      <Popup.Menu.Item onClick={() => change('cumulative')} pressed={goal.progressType === 'cumulative'}>
        <div>
          <b>Total</b><br />
          <small>Aggregate sum</small>
        </div>
      </Popup.Menu.Item>
      <Popup.Menu.Item onClick={() => change('discrete')} pressed={goal.progressType === 'discrete'}>
        <div>
          <b>Differential</b><br />
          <small>Incremental entries</small>
        </div>
      </Popup.Menu.Item>
    </Popup.Menu>
  );
}
